/* eslint-disable max-len */
export default {
    themeConfig: {
        resetClasses: true,

        fieldInputContainer: false,

        formTitle: {
            attributes: {
                class: 'bg-amber-500 px-6 -mx-6 py-4 text-xl font-semibold uppercase text-white mb-4',
            },
        },

        alertError: {
            attributes: {
                class: 'rounded-md bg-red-50 border border-red-200 text-sm text-red-700 p-4 mb-4',
            },
        },

        alertSuccess: {
            attributes: {
                class: 'rounded-md bg-green-50 border border-green-200 text-sm text-green-700 p-4 mb-4',
            },
        },

        buttonWrapper: {
            attributes: {
                class: [
                    'flex justify-start -mx-2',
                    "{{ buttonsPosition == 'right' ? 'justify-end' }}",
                    "{{ buttonsPosition == 'center' ? 'justify-center' }}",
                    "{{ buttonsPosition == 'left-right' ? 'justify-between' }}",
                    "{{ buttonsPosition == 'right-save-left' ? 'justify-start flex-row-reverse' }}",
                    "{{ buttonsPosition == 'center-save-left' ? 'justify-center flex-row-reverse' }}",
                    "{{ buttonsPosition == 'center-save-right' ? 'justify-center' }}",
                    "{{ buttonsPosition == 'save-right' ? 'justify-between' }}",
                    "{{ buttonsPosition == 'save-left' ? 'justify-between flex-row-reverse' }}",
                ],
            },
        },

        buttonContainer: {
            attributes: {
                class: 'flex justify-start',
            },
        },

        saveButton: {
            attributes: {
                class: [
                    'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-600 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                    'mx-2',
                ],
            },
        },

        backButton: {
            attributes: {
                class: [
                    'inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-slate-700 bg-slate-200 hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500',
                    'mx-2',
                ],
            },
        },

        submitButton: {
            attributes: {
                class: [
                    'btn md:ml-auto w-full md:w-auto mx-2 font-semibold order-10 bg-black text-white p-5 rounded-4xl',
                ],
            },
        },

        page: {
            attributes: {
                class: [
                    "{{ form.hasMultiplePages() and page.id != currentPage.id ? 'hidden' : false }}",
                ],
            },
        },

        pageTabs: {
            attributes: {
                class: 'border-b border-neutral-200 -mb-px flex space-x-8 mb-6',
            },
        },

        pageTab: {
            attributes: {
                class: 'py-4 px-1',
            },
        },

        pageTabLink: {
            attributes: {
                class: [
                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
                    "{{ (page.id == currentPage.id) ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-neutral-500 hover:text-neutral-600 hover:border-neutral-300' }}",
                    "{{ page.getFieldErrors(submission) ? 'text-red-500' : false }}",
                ],
            },
        },

        pageTitle: {
            attributes: {
                class: 'text-lg leading-6 font-medium text-neutral-900 mb-4',
            },
        },

        progress: {
            attributes: {
                class: 'flex h-[1.2rem] text-sm text-white bg-slate-200 mt-4',
            },
        },

        progressContainer: {
            attributes: {
                class: 'flex flex-col justify-center text-center font-medium bg-indigo-600',
            },
        },

        subFieldRow: {
            attributes: {
                class: 'flex flex-wrap',
            },
        },

        nestedFieldRows: {
            attributes: {
                class: 'border py-4',
            },
        },

        nestedFieldRow: {
            attributes: {
                class: 'flex flex-wrap mb-4 last:mb-0',
            },
        },

        row: {
            attributes: {
                class: [
                    'flex flex-wrap mb-4',
                    "{{ not craft.formie.getVisibleFields(row) ? 'hidden' }}",
                    "{{ collect(row.fields).pluck('handle').contains('dayserror') ? '-mt-3 text-xs text-neutral-600 blue-links' }}",
                    "{{ collect(row.fields).pluck('handle').contains('newsletterAcceptance') ? 'text-xs text-neutral-600 blue-links' }}",
                    "{{ collect(row.fields).pluck('handle').contains('privacy') ? 'text-xs text-neutral-600 blue-links' }}",
                ],
            },
        },

        field: {
            attributes: {
                class: 'md:pr-2 md:pl-2 w-full md:w-auto md:flex-1 mb-3 md:mb-0 last:mb-0 ',
            },
        },

        fieldLabel: {
            attributes: {
                class: 'mb-1 block text-sm font-medium text-neutral-600',
            },
        },

        fieldRequired: {
            attributes: {
                class: 'text-neutral-600',
            },
        },

        fieldInstructions: {
            attributes: {
                class: 'text-xxs text-blue-500',
            },
        },

        fieldInput: {
            attributes: {
                class: [
                    'p-4 h-64 text-sm w-full bg-transparent placeholder:text-black placeholder:font-semibold placeholder:transition border-black border rounded-2xl',
                    "{{ (submission.getErrors(field.handle) ?? null) ? 'border-red-300' }}",
                ],
            },
        },

        fieldError: {
            attributes: {
                class: 'text-red-500 text-xs mt-1',
            },
        },

        fieldAddButton: {
            attributes: {
                class: 'inline-flex items-center px-4 py-2 border border-transparent text-xs font-medium rounded-md text-slate-700 bg-slate-200 hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500',
            },
        },

        fieldRemoveButton: {
            attributes: {
                class: 'inline-flex items-center px-4 py-2 border border-transparent text-xs font-medium rounded-md text-slate-700 bg-slate-200 hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500',
            },
        },

        fieldLimit: {
            attributes: {
                class: 'mt-2 text-sm text-neutral-500',
            },
        },

        agree: {
            fieldOption: {
                attributes: {
                    class: 'flex items-start mb-2',
                },
            },

            fieldOptionLabel: {
                attributes: {
                    class: 'ml-2 text-base txt leading-4',
                },
            },

            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'shrink-0 focus:ring-blue-500 h-4 w-4 text-indigo-600 border-neutral-300 rounded',
                },
            },
        },

        singleLineText: {
            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'p-4 text-sm w-full bg-transparent placeholder:text-black placeholder:font-semibold placeholder:transition border-black border rounded-4xl',
                },
            },
        },

        multiLineText: {
            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'p-4 h-64 text-xl w-full bg-transparent placeholder:text-black placeholder:font-semibold placeholder:transition border-black border rounded-2xl',
                },
            },
        },

        emailAddress: {
            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'p-4 text-sm w-full bg-transparent placeholder:text-black placeholder:font-semibold placeholder:transition border-black border rounded-4xl',
                },
            },
        },

        phoneNumber: {
            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'p-4 text-sm w-full bg-transparent placeholder:text-black placeholder:font-semibold placeholder:transition border-black border rounded-4xl',
                },
            },
        },

        checkboxes: {
            fieldOption: {
                attributes: {
                    class: 'flex items-start mb-2',
                },
            },

            fieldOptionLabel: {
                attributes: {
                    class: 'ml-2 text-base txt leading-4',
                },
            },

            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'shrink-0 disabled:bg-neutral-100 disabled:text-neutral-300',
                },
            },
        },

        dropdown: {
            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'appearance-none bg-transparent w-full border-b border-neutral-300 border-t-0 border-l-0 border-r-0',
                },
            },
        },

        hiddenField: {
            field: {
                resetClass: true,

                attributes: {
                    class: 'hidden',
                },
            },
        },

        radioButtons: {
            fieldOption: {
                attributes: {
                    class: [
                        'flex flex-wrap items-center mb-2',
                    ],
                },
            },

            fieldOptionLabel: {
                attributes: {
                    class: 'ml-2 text-base txt leading-4',
                },
            },

            fieldInput: {
                resetClass: true,

                attributes: {
                    class: 'disabled:bg-neutral-100 disabled:text-neutral-300',
                },
            },

            fieldOptions: {
                attributes: {
                    class: [
                        'flex gap-2',
                        "{{ field.layout == 'vertical' ? 'flex-col':'flex-row' }}",
                    ],
                },
            },
        },

        recipients: {
            field: {
                attributes: {
                    class: [
                        "{{ field.getIsHidden() ? 'hidden' : false }}",
                    ],
                },
            },
        },

        repeater: {
            nestedField: {
                attributes: {
                    class: 'relative',
                },
            },

            nestedFieldWrapper: {
                attributes: {
                    class: 'mb-4',
                },
            },

            fieldRemoveButton: {
                attributes: {
                    class: 'absolute top-0 right-0 m-1 inline-flex items-center px-2 py-1.5 border border-transparent text-xs font-medium rounded-md text-slate-700 bg-slate-200 hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500',
                },
            },
        },

        signature: {
            fieldInputContainer: {
                attributes: {
                    class: 'relative',
                },
            },

            fieldCanvas: {
                attributes: {
                    class: 'w-full h-[8rem] border bg-slate-100',
                },
            },

            fieldRemoveButton: {
                attributes: {
                    class: 'absolute top-0 right-0 m-1 inline-flex items-center px-2 py-1 border border-slate-300 text-xs font-medium rounded-md text-slate-700 bg-slate-200 hover:bg-slate-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500',
                },
            },
        },

        table: {
            fieldTable: {
                attributes: {
                    class: 'min-w-full divide-y divide-neutral-300',
                },
            },

            fieldTableHeaderColumn: {
                attributes: {
                    class: 'px-3 py-3.5 text-left text-sm font-semibold text-neutral-900',
                },
            },

            fieldTableBody: {
                attributes: {
                    class: 'divide-y divide-neutral-200 bg-white',
                },
            },

            fieldTableBodyColumn: {
                attributes: {
                    class: 'whitespace-nowrap px-3 py-4 text-sm text-neutral-500',
                },
            },
        },
    },
};
